import React from "react";
export const Video = React.memo(({ id, loop }) => {
  const html = `
  <div style="padding:56.25% 0 0 0;position:relative;">
    <iframe
      src="https://player.vimeo.com/video/${id}?autoplay=1&loop=${
    loop ? "1" : "0"
  }&amp;app_id=122963"
      frameborder="0"
      allow="autoplay; fullscreen"
      allowfullscreen
      style="position:absolute;top:0;left:0;width:100%;height:100%;">
    </iframe>
  </div>
  <script src="https://player.vimeo.com/api/player.js"></script>`;
  return <div dangerouslySetInnerHTML={{ __html: html }} className="vimeo" />;
});
